
import { Product } from './types';

export const CATEGORY_MAP: Record<string, string> = {
  'Todo': 'Todo',
  'Hoodies': 'Sudaderas',
  'Sudaderas sin Capucha': 'Sudaderas sin Capucha',
  'T-Shirts': 'Camisetas',
  'Tazas': 'Tazas',
  'Botellas': 'Botellas',
  'Tote bag':'Tote bag',
  'Personalizacion': 'Personalizacion'

};

export type ColorOption = {
  name: string;
  hex: string;
};

export const COLOR_OPTIONS: ColorOption[] = [
  { name: 'Blanco',    hex: '#FFFFFF' },
  { name: 'Negro',     hex: '#000000' },
  { name: 'Rojo',      hex: '#ff0000' },
  { name: 'Azul claro',hex: '#0cdaf5' },
  { name: 'Azul Oscuro',hex: '#020659' },
  { name: 'Amarillo',      hex: '#fffb00' },
  { name: 'Verde',hex: '#006b30' },
  { name: 'Naranja',hex: '#ff9d00' },
  { name: 'Pistacho',hex: '#8cd171' },
  { name: 'Rosa',hex: '#ff78c7' },
  { name: 'Tela',hex: '#e6ddbe' },
  // añade aquí todos los colores que uses en tus productos
];


export const COLOR_SLUGS: Record<string, string> = {
  'Blanco': '_b_',          // Para ropa: _b_
  'Negro': '_n_',       // Para tazas: _negro; para ropa: ajusta si usas 'n' en más productos, pero en tus ejemplos ropa usa '_n_'
  'Rojo': 'rojo',
  'Azul claro': '_azulclaro',
  'Azul Oscuro': '_azuloscuro',
  'Amarillo': '_amarillo',
  'Verde': '_verde',
  'Naranja': '_naranja',
  'Pistacho': '_pistacho',
  'Rosa': '_rosa',
  'Tela': '_tela'          // Para tote bags
};


// Helper con tipado explícito
export function getColorName(hex: string): string {
  const normalized = hex.toLowerCase();
  const option = COLOR_OPTIONS.find((c: ColorOption) => c.hex.toLowerCase() === normalized);
  return option ? option.name : hex; // fallback al hex si no se encuentra
}

export function getProductImageForColor(
  product: Product,
  colorHex: string,
  allImages?: string[]   // opcional: si ya tienes la lista, pásala; si no, la construimos
): string {
  const images = allImages || [
    product.image,
    ...(product.gallery || []),
  ];

  // Reutilizamos la misma lógica que ya tienes en ProductDetail
  const colorName = getColorName(colorHex);
  const slug = COLOR_SLUGS[colorName] || colorName.toLowerCase().replace(/ /g, '');

  const lowerSlug = slug.toLowerCase();

  // Buscamos coincidencia (puedes ajustar el includes si usas _b_ / _n_ etc.)
  const matchingImage = images.find(img => 
    img.toLowerCase().includes(lowerSlug)
  );

  // Fallbacks por orden de preferencia
  return (
    matchingImage ||
    product.image ||           // la principal (debería ser la más genérica o primer color)
    images[0] ||               // cualquier otra
    '/placeholder-product.jpg' // por si acaso (puedes tener un fallback global)
  );
}


export const PRODUCTS: Product[] = [
  {
    id: 'j25_sud_cap',
    name: 'Sudadera Jordi San Andres 2025',
    price: 34.90,
    category: 'Hoodies',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/j25_sud_cap_b_esp2.png',
    gallery: [
      '/j25_sud_cap_b_del2.png',
      '/j25_sud_cap_n_esp2.png', // Detalle espalda
      '/j25_sud_cap_n_del2.png', // Detalle espalda
      '/ph_j25_sud_b_del.png', // Detalle espalda
      '/ph_j25_sud_b_esp.png', // Detalle espalda
      '/ph_j25_sud_n_del.png', // Detalle espalda
      '/ph_j25_sud_n_esp.png'  // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: false
  },
  {
    id: 'r26_cami',
    name: 'Camiseta Renault R26 F1 Fernando Alonso',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Renault',
    description: 'Algodón de alto gramaje',
    image: '/r26_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/r26_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
      '/r26-IL-B.png', 
      '/r26-IL-N.png', // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'mazdalm_botella',
    name: 'Botella isotérmica Mazda 787B Le Mans ',
    price: 21.90,
    category: 'Botellas',
    collection: 'GRAPHIC',
    brand: 'Mazda',
    description: '700 ml • Isotérmica',
    image: '/mazdalm_botella.png',
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },
  {
    id: 'm3min_sud_no_cap',
    name: 'Sudadera Sin Capucha M3 e30',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'MINIMAL',
    brand: 'BMW',
    description: 'Algodón de alto gramaje',
    image: '/m3min_sud_no_cap_n_esp.png',
    gallery: [
      '/sud_no_cap_n_del.png',
      '/m3min_sud_no_cap_b_esp.png', // Detalle espalda
      '/sud_no_cap_b_del.png'  // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'tote_bmwm3',
    name: 'Tote bag BMW M2 e30',
    price: 19.90,
    category: 'Tote bag',
    collection: 'MINIMAL',
    brand: 'BMW',
    description: 'Alto Gramaje',
    image: '/tote_bmwm3.png',
    details: 'Tote Bag calidad PREMIUM. Alto Gramaje.',
    colors: ['#e6ddbe'],
    sizes: ['Talla Única'],
  },

  {
    id: 'lmgt40_cami',
    name: 'Camiseta Ford GT40 Le Mans',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Ford',
    description: 'Algodón de alto gramaje',
    image: '/lmgt40_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/lmgt40_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
 {
    id: '208_graph_sud_cap',
    name: 'Sudadera 208 Rally 4',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/peugeot208_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/peugeot208_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'm3e30_min_taza',
    name: 'Taza BMW M3 e30',
    price: 15.90,
    category: 'Tazas',
    collection: 'MINIMAL',
    brand: 'BMW',
    description: 'Extra Resistente ',
    image: '/m3e30_taza_n_.png',
    gallery: [
      '/m3e30_taza_azulclaro.png',
      '/m3e30_taza_azuloscuro.png',
      '/m3e30_taza_rojo.png', 
      '/m3e30_taza_amarillo.png',
      '/m3e30_taza_verde.png', 
      '/m3e30_taza_naranja.png',
      '/m3e30_taza_pistacho.png',
      '/m3e30_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#000000', '#0cdaf5', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },

{
    id: '208_graph_sud_no_cap',
    name: 'Sudadera Sin Capucha 208 Rally 4',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/peugeot208_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/peugeot208_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'j25_cami',
    name: 'Camiseta Jordi San Andres 2025',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/j25_cami_b_esp2.png',
    gallery: [
      '/j25_cami_b_del2.png',
      '/j25_cami_n_esp2.png', // Detalle espalda
      '/j25_cami_n_del2.png', // Detalle espalda
      '/ph_j25_cami_b_del.png', // Detalle espalda
      '/ph_j25_cami_b_esp.png', // Detalle espalda
      '/ph_j25_cami_n_del.png', // Detalle espalda
      '/ph_j25_cami_n_esp.png'  // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: '208_sud_cap',
    name: 'Sudadera 208 Rally 4',
    price: 34.90,
    category: 'Hoodies',
    collection: 'MINIMAL',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/j25_sud_cap_b_esp2.png',
    gallery: [
      '/sud_b_del.png',
      '/j25_sud_cap_n_esp2.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'lmgt40_taza',
    name: 'Taza Ford GT40 Le Mans',
    price: 15.90,
    category: 'Tazas',
    collection: 'GRAPHIC',
    brand: 'Ford',
    description: 'Extra Resistente ',
    image: '/lmgt40_taza_azulclaro.png',
    gallery: [
      '/lmgt40_taza_n_.png',
      '/lmgt40_taza_azuloscuro.png',
      '/lmgt40_taza_rojo.png', 
      '/lmgt40_taza_amarillo.png',
      '/lmgt40_taza_verde.png', 
      '/lmgt40_taza_naranja.png',
      '/lmgt40_taza_pistacho.png',
      '/lmgt40_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#0cdaf5', '#000000', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },
{
    id: 'stratos_sud_no_cap',
    name: 'Sudadera Sin Capucha Lancia Stratos',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/stratos_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/stratos_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

{
    id: 'lancia_graph_cami',
    name: 'Camiseta Lancia Delta Integrale',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/lancia_graph_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/lancia_graph_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'stratos_sud_cap',
    name: 'Sudadera Lancia Stratos',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/stratos_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/stratos_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },

  {
    id: 'Lancia_integrale_botella',
    name: 'Botella isotérmica Lancia Delta Integrale',
    price: 21.90,
    category: 'Botellas',
    collection: 'MINIMAL',
    brand: 'Lancia',
    description: '700 ml • Isotérmica',
    image: '/lancia_integrale_botella.png',
    gallery: [
      '/ph_lancia_integrale_botella.png',
    ],
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },
  {
    id: 'r26_sud_cap',
    name: 'Sudadera Renualt R26 Fernando Alonso',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Renault',
    description: 'Algodón de alto gramaje',
    image: '/r26_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/r26_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },

  {
    id: 'wosr_cami',
    name: 'Camiseta WOSR 2025',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'MINIMAL',
    brand: 'WOSR',
    description: 'Algodón de alto gramaje',
    image: '/wosr_cami_n_esp2.png',
    gallery: [
      '/cami_n_del.png',
      '/wosr_cami_b_esp2.png', // Detalle espalda
      '/cami_b_del.png', // Detalle espalda
      '/ph_wosr_cami_n_.png' , // Detalle espalda
      '/ph_wosr_cami_b_.png'   // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF',],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'wosr_sud_no_cap',
    name: 'Sudadera Sin Capucha WOSR 2025',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'MINIMAL',
    brand: 'WOSR',
    description: 'Algodón de alto gramaje',
    image: '/wosr_sud_no_cap_n_esp.png',
    gallery: [
      '/sud_no_cap_n_del.png',
      '/wosr_sud_no_cap_b_esp.png', // Detalle espalda
      '/sud_no_cap_b_del.png', // Detalle espalda
      '/ph_wosr_sud_no_cap_n_.png' , // Detalle espalda
      '/ph_wosr_sud_no_cap_b_.png'   // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF',],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: '208r4_min_cami',
    name: 'Camiseta 208 Rally 4',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'MINIMAL',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/j25_cami_b_esp2.png',
    gallery: [
      '/cami_b_del.png',
      '/j25_cami_n_esp2.png', // Detalle espalda
      '/cami_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'lmgt40_sud_cap',
    name: 'Sudadera Ford GT40 Le Mans',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Ford',
    description: 'Algodón de alto gramaje',
    image: '/lmgt40_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/lmgt40_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'R26_botella',
    name: 'Botella isotérmica Renault R26 F1 Fernando Alonso',
    price: 21.90,
    category: 'Botellas',
    collection: 'GRAPHIC',
    brand: 'Renault',
    description: '700 ml • Isotérmica',
    image: '/r26_botella.png',
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },
{
    id: 'lmgt40_sud_no_cap',
    name: 'Sudadera Sin Capucha Ford GT40 Le Mans',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Ford',
    description: 'Algodón de alto gramaje',
    image: '/lmgt40_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/lmgt40_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

{
    id: 'r26_sud_no_cap',
    name: 'Sudadera Sin Capucha Renault R26 Fernando Alonso',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Renault',
    description: 'Algodón de alto gramaje',
    image: '/r26_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/r26_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

{
    id: 'lancia_sud_no_cap',
    name: 'Sudadera Sin Capucha Lancia Delta Integrale',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/lancia_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/lancia_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

  {
    id: '787b_cami',
    name: 'Camiseta Mazda 787B Le Mans',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Mazda',
    description: 'Algodón de alto gramaje',
    image: '/mazda787B_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/mazda787B_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

  {
    id: 'lancia_sud_cap',
    name: 'Sudadera Lancia Delta Integrale',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/lancia_sud_no_no_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/lancia_sud_no_no_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'j25_sud_no_cap',
    name: 'Sudadera Sin Capucha Jordi San Andres 2025',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/j25_sud_no_cap_b_esp.png',
    gallery: [
      '/j25_sud_no_cap_b_del.png',
      '/j25_sud_no_cap_n_esp.png', // Detalle espalda
      '/j25_sud_no_cap_n_del.png', // Detalle espalda
      '/ph_j25_sud_no_cap_b_del.png', // Detalle espalda
      '/ph_j25_sud_no_cap_b_esp.png', // Detalle espalda
      '/ph_j25_sud_no_cap_n_del.png', // Detalle espalda
      '/ph_j25_sud_no_cap_n_esp.png'  // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'lotus72_cami',
    name: 'Camiseta Lotus 72 F1',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Lotus',
    description: 'Algodón de alto gramaje',
    image: '/lotus72_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

  {
    id: 'gt3_sud_cap',
    name: 'Sudadera Porsche GT3 RS',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Porsche',
    description: 'Algodón de alto gramaje',
    image: '/porschegt3_sud_cap_n_esp.png',
    gallery: [
      '/sud_n_del.png',
      '/porschegt3_sud_cap_b_esp.png', // Detalle espalda
      '/sud_b_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF',],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: false
  },
  {
    id: 'lancia_delta_graph_taza',
    name: 'Taza Lancia Delta Integrale',
    price: 15.90,
    category: 'Tazas',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Extra Resistente ',
    image: '/lancia_delta_graph_taza_azuloscuro.png',
    gallery: [
      '/lancia_delta_graph_taza_n_.png',
      '/lancia_delta_graph_taza_azulclaro.png',
      '/lancia_delta_graph_taza_rojo.png', 
      '/lancia_delta_graph_taza_amarillo.png',
      '/lancia_delta_graph_taza_verde.png', 
      '/lancia_delta_graph_taza_naranja.png',
      '/lancia_delta_graph_taza_pistacho.png',
      '/lancia_delta_graph_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#020659', '#000000', '#0cdaf5', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },

{
    id: 'gt3_min_sud_no_cap',
    name: 'Sudadera Sin Capucha Porsche GT3 RS',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'MINIMAL',
    brand: 'Porsche',
    description: 'Algodón de alto gramaje',
    image: '/porschegt3_min_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/porschegt3_min_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'gt3_sud_no_cap',
    name: 'Sudadera Sin Capucha Porsche GT3 RS',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Porsche',
    description: 'Algodón de alto gramaje',
    image: '/porschegt3_sud_no_cap_n_esp.png',
    gallery: [
      '/sud_no_cap_n_del.png',
      '/porschegt3_sud_no_cap_b_esp.png', // Detalle espalda
      '/sud_no_cap_b_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#000000', '#FFFFFF', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

  {
    id: 'm3e30_sil_cami',
    name: 'Camiseta BMW M3 e20',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'MINIMAL',
    brand: 'BMW',
    description: 'Algodón de alto gramaje',
    image: '/m3e30_sil_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/m3e30_sil_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png', //
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000',],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'lotus72_sud_no_cap',
    name: 'Sudadera Sin Capucha Lotus 72 F1',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Lotus',
    description: 'Algodón de alto gramaje',
    image: '/lotus72_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'M3e30_botella',
    name: 'Botella isotérmica BMW M3e30',
    price: 21.90,
    category: 'Botellas',
    collection: 'MINIMAL',
    brand: 'BMW',
    description: '700 ml • Isotérmica',
    image: '/m3e30_botella.png',
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },
 {
    id: 'wosr_sud_cap',
    name: 'Sudadera WOSR 2025',
    price: 34.90,
    category: 'Hoodies',
    collection: 'MINIMAL',
    brand: 'WOSR',
    description: 'Algodón de alto gramaje',
    image: '/wosr_sud_n_esp.png',
    gallery: [
      '/sud_n_del.png',
      '/wosr_sud_b_esp.png', // Detalle espalda
      '/sud_b_del.png', // Detalle espalda
      '/ph_wosr_sud_n_.png', // Detalle espalda
      '/ph_wosr_sud_b_.png', // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: false
  },

{
    id: 'sm_graph_cami',
    name: 'Camiseta Jordi San Andres Rally Sierra Morena 2025',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/peug208r4_graph_cami_b_esp.png',
    gallery: [
      '/j25_cami_b_del2.png',
      '/peug208r4_graph_cami_n_esp.png', // Detalle espalda
      '/j25_cami_n_del2.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'lotus72_sud_cap',
    name: 'Sudadera Lotus 72 F1',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Lotus',
    description: 'Algodón de alto gramaje',
    image: '/lotus72_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'j25_taza',
    name: 'Taza Jordi San Andres 2025',
    price: 15.90,
    category: 'Tazas',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Extra Resistente',
    image: '/j25_taza_n_.png',
    gallery: [
      '/j25_taza_azulclaro.png',
      '/j25_taza_azuloscuro.png',
      '/j25_taza_rojo.png', 
      '/j25_taza_amarillo.png',
      '/j25_taza_verde.png', 
      '/j25_taza_naranja.png',
      '/j25_taza_pistacho.png',
      '/j25_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#000000', '#0cdaf5', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },
  {
    id: 'gt3rs_min_cami',
    name: 'Camiseta Porsche GT3 RS',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'MINIMAL',
    brand: 'Porsche',
    description: 'Algodón de alto gramaje',
    image: '/porschegt3_sil_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/porschegt3_sil_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'countach_sud_no_cap',
    name: 'Sudadera Sin Capucha Lamborhgini Countach',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Lamborghini',
    description: 'Algodón de alto gramaje',
    image: '/lambo_countach_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/lambo_countach_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'j25_botella',
    name: 'Botella isotérmica Jordi San Andres 2025',
    price: 21.90,
    category: 'Botellas',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: '700 ml • Isotérmica',
    image: '/j25_botella.png',    
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },

  {
    id: 'countach_sud_cap',
    name: 'Sudadera Lamborghini Countach',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Lamborghini',
    description: 'Algodón de alto gramaje',
    image: '/lambo_countach_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/lambo_countach_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'countach_cami',
    name: 'Camiseta Lamborghini Countach',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Lamborghini',
    description: 'Algodón de alto gramaje',
    image: '/lambo_contach_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/lambo_contach_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'gt3_min_sud_cap',
    name: 'Sudadera Porsche GT3 RS',
    price: 34.90,
    category: 'Hoodies',
    collection: 'MINIMAL',
    brand: 'Porsche',
    description: 'Algodón de alto gramaje',
    image: '/porschegt3_min_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/porschegt3_min_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: '787B_taza',
    name: 'Taza Mazda 787B Le Mans',
    price: 15.90,
    category: 'Tazas',
    collection: 'GRAPHIC',
    brand: 'Mazda',
    description: 'Extra Resistente ',
    image: '/mazda787B_taza_n_.png',
    gallery: [
      '/mazda787B_taza_azulclaro.png',
      '/mazda787B_taza_azuloscuro.png',
      '/mazda787B_taza_rojo.png', 
      '/mazda787B_taza_amarillo.png',
      '/mazda787B_taza_verde.png', 
      '/mazda787B_taza_naranja.png',
      '/mazda787B_taza_pistacho.png',
      '/mazda787B_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#000000', '#0cdaf5', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  }, 
{
    id: '208rally4_graph_cami',
    name: 'Camiseta 208 Rally 4',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/peug208r4_graph_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/peug208r4_graph_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'wosr_botella',
    name: 'Botella isotérmica WOSR 2025',
    price: 21.90,
    category: 'Botellas',
    collection: 'MINIMAL',
    brand: 'WOSR',
    description: '700 ml • Isotérmica',
    image: '/wosr_botella.png',
    gallery: [
      '/wosr_botella_2.png',
    ],
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },
{
    id: 'sanan_simple_sud_cap',
    name: 'Sudadera Sanan',
    price: 34.90,
    category: 'Hoodies',
    collection: 'MINIMAL',
    brand: 'Sanan',
    description: 'Algodón de alto gramaje',
    image: '/sud_n_del.png',
    gallery: [
      '/sanna_basic_sud_cap_b_esp.png',
      '/sud_b_del.png', // Detalle espalda
      '/sanna_basic_sud_cap_n_esp.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: false
  },


  {
    id: 'lancia_delta_min_taza',
    name: 'Taza Lancia Delta Integrale',
    price: 15.90,
    category: 'Tazas',
    collection: 'MINIMAL',
    brand: 'Lancia',
    description: 'Extra Resistente',
    image: '/lancia_int_min_taza_n_.png',
    gallery: [
      '/lancia_int_min_taza_azulclaro.png',
      '/lancia_int_min_taza_azuloscuro.png',
      '/lancia_int_min_taza_rojo.png', 
      '/lancia_int_min_taza_amarillo.png',
      '/lancia_int_min_taza_verde.png', 
      '/lancia_int_min_taza_naranja.png',
      '/lancia_int_min_taza_pistacho.png',
      '/lancia_int_min_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#000000', '#0cdaf5', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },
{
    id: '208_sud_no_cap',
    name: 'Sudadera Sin Capucha 208 Rally 4',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'MINIMAL',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/j25_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/j25_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'stratos_cami',
    name: 'Camiseta Lancia Stratos',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/stratos_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/stratos_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'sanan_simple_sud_no_cap',
    name: 'Sudadera Sin Capucha Sanan',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'MINIMAL',
    brand: 'Sanan',
    description: 'Algodón de alto gramaje',
    image: '/sud_no_cap_n_del.png',
    gallery: [
      '/sanna_basic_sud_no_cap_n_esp.png',
      '/sud_no_cap_b_del.png', // Detalle espalda
      '/sanna_basic_sud_no_cap_b_esp.png'  // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'GT40_botella',
    name: 'Botella isotérmica Ford GT40 Le Mans',
    price: 21.90,
    category: 'Botellas',
    collection: 'GRAPHIC',
    brand: 'Ford',
    description: '700 ml • Isotérmica',
    image: '/lMGT40_botella.png',
    gallery: [
      '/ph_LMGT40_botella.png',
    ],
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },
{
    id: 'lancia_min_sud_cap',
    name: 'Sudadera Lancia Delta Integrale',
    price: 34.90,
    category: 'Hoodies',
    collection: 'MINIMAL',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/lancia_min_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/lancia_min_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
{
    id: 'lancia_delta_min_cami',
    name: 'Camiseta Lancia Delta Integrale',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'MINIMAL',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/lancia_delta_min_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/lancia_delta_min_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png', // Variante color
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'lancia_min_sud_no_cap',
    name: 'Sudadera Sin Capucha Lancia Delta Integrale',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'MINIMAL',
    brand: 'Lancia',
    description: 'Algodón de alto gramaje',
    image: '/lancia_min_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/lancia_min_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'r26_taza',
    name: 'Taza Renault R26 F1 Fernando Alonso',
    price: 15.90,
    category: 'Tazas',
    collection: 'GRAPHIC',
    brand: 'Renault',
    description: 'Extra Resistente ',
    image: '/r26_taza_azulclaro.png',
    gallery: [
      '/r26_taza_n_.png',
      '/r26_taza_azuloscuro.png',
      '/r26_taza_rojo.png', 
      '/r26_taza_amarillo.png',
      '/r26_taza_verde.png', 
      '/r26_taza_naranja.png',
      '/r26_taza_pistacho.png',
      '/r26_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#0cdaf5', '#000000', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },
{
    id: 'm3e30_sud_cap',
    name: 'Sudadera BMW M3 E30',
    price: 34.90,
    category: 'Hoodies',
    collection: 'MINIMAL',
    brand: 'BMW',
    description: 'Algodón de alto gramaje',
    image: '/m3e30_sud_cap_n_esp.png',
    gallery: [
      '/sud_n_del.png',
      '/m3e30_sud_cap_b_esp.png', // Detalle espalda
      '/sud_b_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#000000', '#FFFFFF'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: false
  },
{
    id: 'sanan_cami',
    name: 'Camiseta SANAN Simple',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'MINIMAL',
    brand: 'Sanan',
    description: 'Algodón de alto gramaje',
    image: '/cami_b_del.png',
    gallery: [
      '/sanan_cami_b_esp.png',
      '/cami_n_del.png', // Detalle espalda
      '/sanan_cami_n_esp.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'j25_tote',
    name: 'Tote bag Jordi San Andres 2025',
    price: 19.90,
    category: 'Tote bag',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Alto Gramaje',
    image: '/j25_tote.png',
    details: 'Tote Bag calidad PREMIUM. Alto Gramaje.',
    colors: ['#e6ddbe'],
    sizes: ['Talla Única'],
  },

{
    id: '787b_sud_no_cap',
    name: 'Sudadera Sin Capucha Mazda 787B Le Mans',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    brand: 'Mazda',
    description: 'Algodón de alto gramaje',
    image: '/mazda787b_sud_no_cap_b_esp.png',
    gallery: [
      '/sud_no_cap_b_del.png',
      '/mazda787b_sud_no_cap_n_esp.png', // Detalle espalda
      '/sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'wosr_taza',
    name: 'Taza WOSR 2025',
    price: 15.90,
    category: 'Tazas',
    collection: 'MINIMAL',
    brand: 'WOSR',
    description: 'Extra Resistente ',
    image: '/wosr_taza_n_.png',
    gallery: [
      '/wosr_taza_azulclaro.png',
      '/wosr_taza_azuloscuro.png',
      '/wosr_taza_rojo.png', 
      '/wosr_taza_amarillo.png',
      '/wosr_taza_verde.png', 
      '/wosr_taza_naranja.png',
      '/wosr_taza_pistacho.png',
      '/wosr_taza_rosa.png',
    ],
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#000000', '#0cdaf5', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['Talla Única'],
  },
  {
    id: '787b_sud_cap',
    name: 'Sudadera Maxda 787B Le Mans',
    price: 34.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    brand: 'Mazda',
    description: 'Algodón de alto gramaje',
    image: '/mazda787b_sud_cap_b_esp.png',
    gallery: [
      '/sud_b_del.png',
      '/mazda787b_sud_cap_n_esp.png', // Detalle espalda
      '/sud_n_del.png', 
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: true
  },
  {
    id: 'lancia_integrale_graph_botella',
    name: 'Botella isotérmica Lancia Delta Integrale',
    price: 21.90,
    category: 'Botellas',
    collection: 'GRAPHIC',
    brand: 'Lancia',
    description: '700 ml • Isotérmica',
    image: '/lancia_integrale_graph_botella.png',
    gallery: [
      '/ph_lancia_integrale_graph_botella.png',
    ],
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['Talla Única'],
  },

  {
    id: '208_sm_sud_no_cap',
    name: 'Sudadera Sin Capucha Jordi San Andres Sierra Morena 2025',
    price: 33.90,
    category: 'Sudaderas sin Capucha',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/peugeot208_sud_no_cap_b_esp.png',
    gallery: [
      '/j25_sud_no_cap_b_del.png',
      '/peugeot208_sud_no_cap_n_esp.png', // Detalle espalda
      '/j25_sud_no_cap_n_del.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: [ '#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: 'gt3rs_graph_cami',
    name: 'Camiseta Porsche GT3 RS',
    price: 24.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    brand: 'Porsche',
    description: 'Algodón de alto gramaje',
    image: '/porschegt3_graph_cami_b_esp.png',
    gallery: [
      '/cami_b_del.png',
      '/porschegt3_graph_cami_n_esp.png', // Detalle espalda
      '/cami_n_del.png',
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
{
    id: '208_sm_sud_cap',
    name: 'Sudadera Jordi San Andres Sierra Morena 2025',
    price: 34.90,
    category: 'Hoodies',
    collection: 'SANAN',
    brand: 'Peugeot',
    description: 'Algodón de alto gramaje',
    image: '/peugeot208_sud_cap_b_esp.png',
    gallery: [
      '/j25_sud_cap_b_del2.png',
      '/peugeot208_sud_cap_n_esp.png', // Detalle espalda
      '/j25_sud_cap_n_del2.png', // Detalle espalda
    ],
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000'],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
    isNew: false
  },
];





// PRODUCTOS ESPECIALES DE PERSONALIZACIÓN
export const DESIGN_FEE_VECTORIAL: Product = {
  id: 'design-fee-vectorial',
  name: 'Diseño Premium Vectorial',
  price: 29.90,
  category: 'Personalizacion',
  collection: 'GRAPHIC',
  description: 'Digitalización y diseño vectorial profesional (vista lateral estilizada)',
  image: '/vector_original.png',
  details: 'Servicio premium: transformamos tu foto en ilustración vectorial de alta definición. Pago único.',
  colors: ['#000000'],
  sizes: ['Único'],
};

export const DESIGN_FEE_FOTO_DIRECTA: Product = {
  id: 'design-fee-foto-directa',
  name: 'Vectorización de Fotografía',
  price: 13.90,
  category: 'Personalizacion',
  collection: 'GRAPHIC',
  description: 'Uso directo de la foto enviada sin vectorización ni retoques',
  image: '/vector_foto_n_.png',
  details: 'Opción económica: imprimimos directamente tu foto tal cual. Más rápido y barato.',
  colors: ['#000000'],
  sizes: ['Único'],
};

export const CUSTOM_BASE_PRODUCTS: Product[] = [
  {
    id: 'custom-hoodie',
    name: 'Sudadera Personalizada',
    price: 33.90,
    category: 'Hoodies',
    collection: 'GRAPHIC',
    description: 'Algodón de alto gramaje',
    image: '/sud_b_del.png',
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'custom-sudadera_sin',
    name: 'Sudadera SIN Capucha Personalizada',
    price: 32.90,
    category: 'Sudaderas sin Capucha',
    collection: 'GRAPHIC',
    description: 'Algodón de alto gramaje',
    image: '/sud_no_cap_b_del.png',
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000', ],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },

  {
    id: 'custom-tshirt',
    name: 'Camiseta Personalizada',
    price: 22.90,
    category: 'T-Shirts',
    collection: 'GRAPHIC',
    description: 'Algodón de alto gramaje',
    image: '/cami_b_del.png',
    details: '100% Algodón, Calidad PREMIUM. Pre-encogido para mantener el ajuste perfecto tras el lavado.',
    colors: ['#FFFFFF', '#000000',],
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'],
  },
  {
    id: 'custom-taza',
    name: 'Taza Personalizada',
    price: 14.90,
    category: 'Tazas',
    collection: 'GRAPHIC',
    description: '330 ml • Extra Resistente',
    image: '/taza_person.png',
    details: 'Calidad PREMIUM. Apta para microondas y lavavajillas',
    colors: ['#000000', '#0cdaf5', '#020659', '#ff0000', '#fffb00', '#006b30', '#ff9d00', '#8cd171', '#ff78c7',],
    sizes: ['330ml'],
  },
  {
    id: 'custom-bottle',
    name: 'Botella Térmica Personalizada',
    price: 20.90,
    category: 'Botellas',
    collection: 'GRAPHIC',
    description: '700 ml • Isotérmica',
    image: '/person_botella.png',
    details: 'Botella isotérmica calidad PREMIUM. Aguanta frío y calor durante horas.',
    colors: ['#FFFFFF'],
    sizes: ['700ml'],
  },
  {
    id: 'custom-tote',
    name: 'Tote Bag Personalizada',
    price: 18.90,
    category: 'Botellas',
    collection: 'GRAPHIC',
    description: 'Alto Gramaje',
    image: '/tote_person.png',
    details: 'Tote Bag calidad PREMIUM. Alto Gramaje.',
    colors: ['#FFFFFF'],
    sizes: ['700ml'],
  },
];

